/* eslint-disable spire/export-styles */
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { useEffect, useState } from "react";

const enum fields {
    bodyScript = "bodyScript",
}

interface Props extends WidgetProps {
    fields: {
        [fields.bodyScript]: string;
    };
}

export const InsertJsBody: React.FunctionComponent<Props> = props => {
    const [isLoaded, setIsLoaded] = useState(false);
    const bodyScriptId = "bodyscriptid";
    const bodyScript = props.fields.bodyScript;

    useEffect(() => {
        if (!document.getElementById(bodyScriptId)) {
            loadScript();
        } else {
            setIsLoaded(false);
        }
    }, [bodyScript]);

    const loadScript = () => {
        const s = document.createElement("script");
        s.id = bodyScriptId;
        s.type = "text/javascript";
        s.async = true;
        s.innerHTML = bodyScript;
        s.onload = () => setIsLoaded(true);
        document.getElementsByTagName("body")[0].appendChild(s);
    };
    return <></>;
};

const widgetModule: WidgetModule = {
    component: InsertJsBody,
    definition: {
        group: "Basic",
        icon: "FormField",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.bodyScript,
                editorTemplate: "TextField",
                displayName: "Body Script Code",
                defaultValue: "",
            },
        ],
    },
};
export default widgetModule;
